import config from 'devextreme/core/config';

const dxLicenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjMyZWNmNWEwLTM5ODMtNDYyZS05YTgyLTY5NWFjODgzM2RkYiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.MKfK2043JnHwzzKl+/cRwF3o8m3Y1de/b83DsFiTRLH9o2movCphkTw0sfva2Jsk864L9kJy/AaHPWBZf7h8rKFo7bdOYMeTiqjtpQsGpf5G2x/A5O+A0P++ZY1n81Lg8RXIIQ==';

export function setupDxLicense() {
  config({ licenseKey: dxLicenseKey });
}
